import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Table,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  DialogProps,
  Stack,
  CircularProgress,
  Paper, // Used for card-like appearance
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Collapse
} from "@mui/material";
import Logo from "../../../assets/images/CSJMUlog.png";
import Watermark from "../../../assets/images/CSJMUlogo.png";
// Add these imports if not already present

import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import api from "../../../utils/Url"; // Assuming this path is correct
import Autocomplete from "@mui/material/Autocomplete";
import { toast, ToastContainer } from "react-toastify";
// import dayjs from "dayjs"; // Not used in the provided snippet's logic directly for display formatting that MUI can't handle
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
// import { CheckBox } from "@mui/icons-material"; // Not the standard MUI Checkbox icon
import { useReactToPrint } from "react-to-print";
import loged from "../../../assets/images/DrawerLogo.png"; // Assuming path
import profile1 from "../../../assets/images/profile1.png"; // Assuming path
import Moment from 'react-moment';
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { t } from "i18next"; // Assuming i18next setup
// import { Card } from "@mui/material/node"; // Use Card from @mui/material
import { Card } from "@mui/material";
import { useUserId } from "../../../utils/Constant"; // Assuming path
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog"; // PrimeReact component
import OverdueListDialog from "../../home/OverdueList"; // Assuming path

// MUI Icons
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ScanIcon from '@mui/icons-material/Scanner';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import BlockIcon from '@mui/icons-material/Block';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PrintIcon from '@mui/icons-material/Print';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from "moment";


type Props = {};

const selectOption = [
  { value: 1, label: "Antenna-1" },
  { value: 2, label: "Antenna-2" },
  { value: 3, label: "Antenna-3" },
  { value: 4, label: "Antenna-4" },
  { value: 5, label: "Antenna-8" },
];

interface memberOption {
  empName: string;
  empCode: string;
  empMobileNo: string;
  empPanNumber: string;
  email: string;
  empDob: string;
  departmentName: string;
  designationName: string;
  value: string;
}

interface FileOption {
  value: number;
  fileName: string;
  fileNo?: string;
  synopsis: string;
  remark: string;
  totalPages: string;
  rfid: string;
  chackNo: string;
}

const IssueReturn = (props: Props) => {
  // ... (all your existing state variables and functions remain the same)
  //Member Detail Section
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [program, setProgram] = useState<string | null>(null);
  const [department1, setDepartment1] = useState<string | null>(null);
  const [category, setCategory] = useState<string | null>(null);
  const [programOptions, setProgramOptions] = useState<{ value: string, label: string }[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<{ value: string, label: string }[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<{ value: string, label: string }[]>([]);

  const [todayStillInsideCount, setTodayStillInsideCount] = useState<number | null>(null);
  const [todayVisitorCount, setTodayVisitorCount] = useState<number | null>(null);
  const [loadingCounts, setLoadingCounts] = useState({
    stillInside: false,
    visitor: false
  });


  const [visitorDialogOpen, setVisitorDialogOpen] = useState(false);
  const [visitorData, setVisitorData] = useState<any[]>([]);
  const [visitorLoading, setVisitorLoading] = useState(false);

  const [visitorInfoDialogOpen, setVisitorInfoDialogOpen] = useState(false);
  const [visitorInfoData, setVisitorInfoData] = useState<any[]>([]);
  const [visitorInfoLoading, setVisitorInfoLoading] = useState(false);

  const [timePeriod, setTimePeriod] = useState('Today');
  // const [fromDate, setfromDate] = useState<string>(() => new Date().toISOString().split('T')[0]);
  // const [toDate, settoDate] = useState<string>(() => new Date().toISOString().split('T')[0]);

  const [show, setShow] = useState(false);

  const [show1, setShow1] = useState(true);

  const [show2, setShow2] = useState(false);
  const [membCode, setmembCode] = useState("");
  const [memberCode, setmemberCode] = useState("");
  const [fromDate, setfromDate] = useState<string | null>(null);
  const [toDate, settoDate] = useState<string | null>(null);
  const [memberGroup, setMemberGroup] = useState("");
  const [department, setDepartment] = useState("");
  const [issuesLimit, setIssuesLimit] = useState("");
  const [courseDesignation, setCourseDesignation] = useState("");
  const [alreadyIssued, setAlreadyIssued] = useState("");
  const [issueDays, setIssueDays] = useState("");
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [slipprint, setSlipprint] = useState(false);
  const [memberOption, setMemberOption] = useState<memberOption[] | any>([]);
  const [loading, setLoading] = useState(false);
  const [isScanloading, setIsScanLoading] = useState(false);

  const [antina, setAntina] = useState<any>();
  const [antinaselect, setAntinaselect] = useState<any>(selectOption[0]);

  const [option, setOption] = useState<any>([{ value: "-1", label: "No members found" }]);
  const [fileDetails, setFileDetails] = useState<FileOption[] | any>([]);
  const [fileDetailsTableData, setFileDetailsTableData] = useState<any>([]);
  const [bookTableData, setBookTableData] = useState<any>([]);
  const [printData, setPrintData] = useState<any>([]);

  const [selectedCheckbox, setSelectedCheckbox] = useState<string | null>(null);


  const getMemb = async (nameData: string) => {
    if (!nameData || nameData.length < 1) {
      setOption([{ value: "-1", label: "Type to search members" }]);
      return;
    }
    try {
      const res = await api.get(`AssigningRfid/GetMember?name=${nameData}`);
      const transformedData = res?.data?.map((item: any) => ({
        value: item?.value,
        label: item?.label
      }));
      setOption(
        []
      );
    } catch (error) {
      console.error("Error fetching applicable accession:", error);
      setOption([
        { value: "-1", label: "Error fetching members" },
      ]);
    }
  };

  const fetchPrograms = () => {
    const collectData = { branch_cd: "", branch_name: "" };
    api.post(`Member/Getm_prgram`, collectData)
      .then((response) => {
        if (response.data?.data) {
          setProgramOptions(response.data.data.map((item: any) => ({
            label: `${item.branch_name} (${item.branch_cd})`,
            value: item.branch_cd
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching programs:", error);
        setProgramOptions([]);
      });
  };

  const fetchDepartments = () => {
    const collectData = { fld_tag: "" };
    api.post(`Member/Getm_fcltydept`, collectData)
      .then((response) => {
        if (response.data?.data) {
          setDepartmentOptions(response.data.data.map((item: any) => ({
            label: `${item.fclty_dept_dscr} (${item.fclty_dept_cd})`,
            value: item.fclty_dept_cd
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching departments:", error);
        setDepartmentOptions([]);
      });
  };

  const fetchCategories = () => {
    api.post(`Member/Getm_ctgry`, { ctgry_cd: "" })
      .then((response) => {
        if (response.data?.data) {
          setCategoryOptions(response.data.data.map((item: any) => ({
            label: `${item.ctgry_desc} (${item.ctgry_cd})`,
            value: item.ctgry_cd
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
        setCategoryOptions([]);
      });
  };

  useEffect(() => {

    fetchPrograms();
    fetchDepartments();
    fetchCategories();
    handleTimePeriodChange('Today');

  }, []);

  //FileDetails Tran section
  const [chakno, setChakNo] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileNo, setFileNo] = useState("");
  const [remark, setRemark] = useState("");
  const [rfid, setRFID] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [totalPages, setTotalPages] = useState("");
  const [btnissue, setBtnissue] = useState("Issue / Return");

  const [isChecked, setIsChecked] = useState(false);

  const [LocationOption, setLocationOption] = useState<any>([
    { value: "-1", label: "Select To Location" },
  ]);

  const [receiverName, setReceiverName] = useState("");
  const [senderName, setSenderName] = useState("");
  const [selectedLocationLabel, setSelectedLocationLabel] = useState('');
  const [fileIDs, setFileID] = useState("");
  const [slipno, setSlipNo] = useState("");

  const [totalIssue, setTotalIssue] = useState(0);
  const [todayIssue, setTodayIssue] = useState(0);
  const [todayReturn, settodayReturn] = useState(0);

  const [isDefaultValueSet, setIsDefaultValueSet] = useState(false);
  const [applicableAcceOption, setASpplicableAcceOption] = useState<any>([{ value: "-1", label: ("Member Code") }]);
  const [termData, setTermData] = useState("")
  const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null);
  const [applicableAcceOptionMemName, setApplicableAcceOptionMemName] = useState<any>([{ value: "-1", label: ("Member Code") }]);
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [issuetype, SetIssuetype] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [studentimage, SetStudentImage] = useState("");
  if (!isDefaultValueSet) {
    const defaultLocation = LocationOption.find(
      (option: any) => option.value === parseInt(synopsis)
    );

    if (defaultLocation) {
      setSelectedLocationLabel(defaultLocation.label);
      setIsDefaultValueSet(true);
    }
  }


  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('lg');
  const [titlename, settitlename] = React.useState("Total Issue");
  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [Userid, setUserId] = useUserId();

  const [openDialog, setOpenDialog] = React.useState(false);

  // FIX: Added state for dialog filters to keep them separate from main page logic
  const [dialogMemberCode, setDialogMemberCode] = useState<string | null>(null);
  const [dialogMemberOptions, setDialogMemberOptions] = useState<any>([]);
    
  // --- CAMBIO 1: Creación de la función de reseteo ---
  const resetUI = () => {
    setFileDetailsTableData([]);
    setBookTableData([]);
    setAccordionExpanded(false);
    setASpplicableAcceOption([]);
    SetStudentImage("");
    setShow(false);
    setLoading(false);
    setmembCode("");
    setSelectedCheckbox(null);
    setShow1(true);
    setShow2(false);
  };

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        setLoadingCounts(prev => ({ ...prev, stillInside: true }));
        const stillInsideRes = await api.post('AssigningRfid/CountTodayStillInside');
        if (stillInsideRes.data.isSuccess && stillInsideRes.data.data?.length > 0) {
          setTodayStillInsideCount(stillInsideRes.data.data[0].visitorCount);
        }
      } catch (error) {
        console.error('Error fetching still inside count:', error);
      } finally {
        setLoadingCounts(prev => ({ ...prev, stillInside: false }));
      }

      try {
        setLoadingCounts(prev => ({ ...prev, visitor: true }));
        const visitorRes = await api.post('AssigningRfid/CountTodayVisit');
        if (visitorRes.data.isSuccess && visitorRes.data.data?.length > 0) {
          setTodayVisitorCount(visitorRes.data.data[0].visitorCount);
        }
      } catch (error) {
        console.error('Error fetching visitor count:', error);
      } finally {
        setLoadingCounts(prev => ({ ...prev, visitor: false }));
      }
    };

    fetchCounts();
  }, []);


  const handleTimePeriodChange = (period: string) => {
    setTimePeriod(period);
    const today = new Date();
    const todayStr = formatDate(today);

    switch (period) {
      case 'Today':
        setfromDate(todayStr);
        settoDate(todayStr);
        break;
      case 'Weekly':
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 6);
        setfromDate(formatDate(sevenDaysAgo));
        settoDate(todayStr);
        break;
      case 'Monthly':
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        setfromDate(formatDate(firstDayOfMonth));
        settoDate(todayStr);
        break;
      case 'Yearly':
        setfromDate(formatDate(new Date(today.getFullYear(), 0, 1)));
        settoDate(todayStr);
        break;
      case 'Custom':
        // Keep current dates but ensure they're not null
        setfromDate(prev => prev || todayStr);
        settoDate(prev => prev || todayStr);
        break;
    }
  };

  // Helper function to format dates consistently
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const handleSearch = async () => {
    try {
      setVisitorInfoLoading(true);

      // Preserve all filter states
      const searchParams = {
        vdate: fromDate || new Date().toISOString().split('T')[0],
        todate: timePeriod === 'Today' ? fromDate : toDate,
        m_memcd: dialogMemberCode || "",
        mem_dept: department1 || "",
        mem_degree: program || "",
        mem_ctgry: category || ""
      };

      const response = await api.post('Member/GetvisitorInfo', searchParams);

      if (response.data.isSuccess && response.data.data) {
        setVisitorInfoData(response.data.data);
      } else {
        setVisitorInfoData([]);
        toast.info(response.data.mesg || "No visitor data found");
      }
    } catch (error) {
      console.error('Error fetching visitor info:', error);
      toast.error("Failed to fetch visitor information");
      setVisitorInfoData([]);
    } finally {
      setVisitorInfoLoading(false);
    }
  };

  const fetchVisitorInfoStillInside = async () => {
    setVisitorLoading(true);
    try {
      const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

      // Prepare base params with default today's date if not set
      const params: any = {
        vdate: fromDate || today, // Use today if fromDate is null
        m_memcd: dialogMemberCode || "",
        mem_dept: department1 || "",
        mem_degree: program || "",
        mem_ctgry: category || ""
      };

      // Handle todate based on time period
      if (timePeriod !== 'Today') {
        params.todate = toDate || today; // Use today if toDate is null
      } else {
        params.todate = fromDate || today; // For Today, use fromDate or today
      }

      const response = await api.post('Member/GetvisitorInfo', params);

      if (response.data.isSuccess && response.data.data) {
        // Only include visitors whose outTime is null
        const filtered = response.data.data.filter((item: any) => item.outTime === null);
        setVisitorData(filtered);
      } else {
        setVisitorData([]);
        toast.info(response.data.mesg || "No visitor data found");
      }
    } catch (error) {
      console.error('Error fetching visitor info:', error);
      toast.error("Failed to fetch visitor information");
      setVisitorData([]);
    } finally {
      setVisitorLoading(false);
    }
  };

  const fetchVisitorInfo = async () => {
    setVisitorInfoLoading(true);
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const params = {
        vdate: currentDate,
        todate: currentDate, // Same as vdate for default Daily view
        m_memcd: "",
        mem_dept: "",
        mem_degree: "",
        mem_ctgry: ""
      };

      const response = await api.post('Member/GetvisitorInfo', params);

      if (response.data.isSuccess && response.data.data) {
        setVisitorInfoData(response.data.data);
      } else {
        setVisitorInfoData([]);
        toast.info(response.data.mesg || "No visitor data found");
      }
    } catch (error) {
      console.error('Error fetching visitor info:', error);
      toast.error("Failed to fetch visitor information");
      setVisitorInfoData([]);
    } finally {
      setVisitorInfoLoading(false);
    }
  };

  const handleClickOpen = (title: any) => {
    settitlename(title);
    if (title == "Total Issued") {
      getList("all");
    } else if (title == "Today Issued") {
      getList("issue");
    } else if (title == "Today Return") {
      getreturnList("return");
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // FIX: Reset all dialog-related states on close
    setRows([]);
    setColumns([]);
    setfromDate(null);
    settoDate(null);
    setDialogMemberCode(null);
    setDialogMemberOptions([]);
  };
  const contentRef = useRef(null);

  const handleDialogPrint = (data: any[], title: string) => {
    if (!data || data.length === 0) {
      toast.error("No data to print!");
      return;
    }

    const printWindow = window.open("", "_blank");
    const content = `
    <html>
    <head>
        <title>Print Report - CSJMU Library</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                margin: 20px;
                position: relative;
            }

            .header {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 30px 0;
                margin-bottom: 30px;
                position: relative;
            }

            .logo {
                width: 100px;
                height: auto;
            }

            .header-center {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                flex: 1;
            }

            .title {
                font-size: 24px;
                font-weight: bold;
                color: #0d3b5c;
                text-transform: uppercase;
                text-align: center;
            }

            .centered-heading {
                text-align: center;
                margin: 0;
                font-size: 20px;
                font-weight: bold;
                color: #0d3b5c;
            }

            h2 {
                text-align: center;
                margin-bottom: 20px;
                color: #0d3b5c;
            }

            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 10px;
                position: relative;
                z-index: 2;
            }

            th, td {
                border: 1px solid black;
                padding: 10px;
                text-align: left;
            }

            th {
                background-color: #0d3b5c;
                color: white;
                text-align: center;
            }

            td {
                text-align: center;
            }

            .watermark {
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50%;
                height: auto;
                z-index: 1;
                opacity: 0.8;
            }
        </style>
    </head>
    <body>
        <!-- Header -->
        <div class="header">
            <div style="width:100px;display:flex;align-items:center;justify-content:center;">
                <img class="logo" src="${Logo}" alt="CSJMU Logo" id="logo">
            </div>
            <div class="header-center">
                <div class="title">CSJMU LIBRARY KANPUR</div>
                <div class="centered-heading">GSV Central Libarary</div>
                <h2 style="margin:0;">${title}</h2>
            </div>
            <div style="width:100px;"></div>
        </div>

        <!-- Watermark -->
        <img class="watermark" src="${Watermark}" alt="Watermark Logo" id="watermark">

        <!-- Report Table -->
        <table>
            <thead>
                <tr>
                    <th>Member Code</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Category</th>
                    <th>Program</th>
                    <th>Department</th>
                    <th>Member Type</th>
                    <th>Visit Date</th>
                    <th>IN Time</th>
                    <th>Out Time</th>
                    <th>Time Spent</th>
                </tr>
            </thead>
            <tbody>
                ${data.map((row: any) => `
                  <tr>
                      <td>${row.m_memcd || '-'}</td>
                      <td>${row.mname || '-'}</td>
                      <td>${row.mobileNo || '-'}</td>
                      <td>${row.mem_ctgry || '-'}</td>
                      <td>${row.mem_degree || '-'}</td>
                      <td>${row.mem_dept || '-'}</td>
                      <td>${row.mem_type || '-'}</td>
                      <td>${row.vdate ? moment(row.vdate).format("DD/MM/YYYY") : '-'}</td>
                      <td>${row.inTime ? moment(row.inTime).format("hh:mm A") : '-'}</td>
                      <td>${row.outTime ? moment(row.outTime).format("hh:mm A") : '-'}</td>
                      <td>${row.spendtime || '-'}</td>
                  </tr>
              `).join("")}
            </tbody>
        </table>

        <script>
            function waitForImages() {
                const images = document.querySelectorAll("img");
                let loadedCount = 0;

                images.forEach(img => {
                    if (img.complete) {
                        loadedCount++;
                    } else {
                        img.onload = img.onerror = () => {
                            loadedCount++;
                            if (loadedCount === images.length) {
                                window.print();
                            }
                        };
                    }
                });

                if (loadedCount === images.length) {
                    window.print();
                }
            }

            waitForImages();
        </script>
    </body>
    </html>
  `;

    if (printWindow) {
      setTimeout(() => {
        printWindow.document.write(content);
        printWindow.document.close();
      }, 1000);
    } else {
      console.error("Failed to open print window.");
    }
  };

  const handleDirectPrint = () => {
    const printContent = document.getElementById("receipt-content")?.innerHTML;
    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow?.document.write(`
        <html>
        <head>
          <title>Print Receipt</title>
          <style>
            @page { size: 50mm auto; margin: 8; }
            body { font-family: Arial, sans-serif; font-size: 11px; text-align: center; }
            .pos-receipt { width: 85mm; }
            table { width: 100%; border-collapse: collapse; }
            td { padding: 2px;font-size: 10px; }
            .pos-title { font-size: 13px; font-weight: bold; }
            .pos-footer { font-size: 10px; margin-top: 5px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContent}
        </body>
        </html>
      `);
      printWindow?.document.close();
    }
  };

  const handleChange = () => {
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    getTotalIssueReturn();
    getTodayIssue();
    getTodayReturn();
    getMaxSlipNo();
    setAntina(antinaselect.value);
  }, []);

  const getTotalIssueReturn = () => {
    api.get(`Member/GetTotalIssueReturn?USER_ID=${Userid}`).then((res) => {
      setTotalIssue(res.data.data);
    });
  };

  const getTodayIssue = () => {
    api.get(`Member/GetTodayIssue?USER_ID=${Userid}`).then((res) => {
      setTodayIssue(res.data.data);
    });
  };

  const getTodayReturn = () => {
    api.get(`Member/GetTodayReturn?USER_ID=${Userid}`).then((res) => {
      settodayReturn(res.data.data);
    });
  };

  const getMaxSlipNo = () => {
    api.get(`Member/GetMaxSlipNo`).then((res) => {
      setSlipNo(res.data.data[0]["slip_no"]);
    });
  };

  const getBlockMember = (membrCode: any) => {
    api.get(`Member/GetMemberCardStatus?mem_code=${membrCode}`).then((res) => {
      if (res?.data?.data?.cardStatus === "Blocked") {
        setShow1(false);
        setShow2(true);
      }
    });
  };

  const getIP = async () => {
    const url = `http://localhost:8080/api/Aratek/GetSystemIp?user=abc&pllas=xyz`;
    try {
      const response = await axios.get(url);
      return response.data.data.ip;
    } catch (error) {
      console.error('Error getting IP:', error);
      return null;
    }
  };

  const getAntennaScan = async () => {
    const systemIp = await getIP();
    setLoading(true);
    if (!antina) {
      toast.error("Please Select Any one Antenna");
      setLoading(false);
      return;
    }

    const collectData = {
      epc: "",
      antnum: antina.toString(),
      type: "Issue",
      systemip: systemIp
    };

    try {
      const response = await api.post('AssigningRfid/GetRfid', collectData);
      setLoading(false);
      
      // --- CAMBIO 2: Lógica de reseteo si el escaneo falla ---
      if (!response.data.isSuccess) {
        toast.error(response.data.mesg || "No Data Found!");
        if (response.data.mesg === "No one card or book available for scan") {
          resetUI();
        }
        return;
      }

      if (response?.data?.data) {
        setShow(true);
        let memberDetailarr = [];
        let bookDetailsarr = [];

        for (const item of response.data.data) {
          if (item.memberdetcls) {
            for (const member of item.memberdetcls) {
              memberDetailarr.push({
                memberCode: member.mem_cd,
                rfid: member.rfid,
                firstName: member.mem_firstnm,
                middleName: member.mem_midnm,
                lastName: member.mem_lstnm,
                effectUpto: member.mem_effctupto,
                memCategory: member.mem_ctgry
              });
              var name = member.mem_firstnm;
              getMemberPhoto(member.mem_cd);
              setASpplicableAcceOption([{ value: member.mem_cd, label: name }]);
              setmembCode(member.mem_cd);
              getBlockMember(member.mem_cd);
            }
          }
        }
        setFileDetailsTableData(memberDetailarr);

        for (const item of response.data.data) {
          if (item.bookaccesioncls) {
            for (const book of item.bookaccesioncls) {
              bookDetailsarr.push({
                checkbox: false,
                recID: book.recID,
                p852: book.p852,
                status: book.status,
                tag245a: book.tag245a,
                tag245c: book.tag245c,
                lastOperatedDT: book.lastOperatedDT,
                mem_cd: book.mem_cd,
                issdmem_cd: book.issdmem_cd,
                iss_dt: book.iss_dt === null ? "" : book.iss_dt,
                due_dt: book.due_dt === null ? "" : book.due_dt,
                epc_match_status: book.epc_match_status
              });
            }
          }
        }
        setBookTableData(bookDetailsarr);
        setAccordionExpanded(true);
        toast.success(response?.data?.mesg);
      } else {
        toast.info("No member or book data found in scan.");
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
      toast.error("Failed to fetch data. Please try again.");
    }
  };

  const getMemberPhoto = async (memberCode: any) => {
    const collectData = {
      mem_cd: memberCode,
      member_photo: "",
      mem_photo_path: "",
      show: true,
      exportOption: "",
    };
    try {
      const response = await api.post(`Member/GetmemPhoto`, collectData);
      if (response.data.data === null || !response.data.data["member_photo_base64"]) {
        SetStudentImage(profile1); // Use default profile if no image
        return;
      }
      var member_photo_base64 = response.data.data["member_photo_base64"];
      SetStudentImage("data:image/png;base64," + member_photo_base64);
    } catch (error) {
      console.error("Error fetching member photo:", error);
      SetStudentImage(profile1); // Fallback to default on error
    }
  };


  useEffect(() => {
    if (fileDetailsTableData.length === 0) {
      SetStudentImage("");
    }
  }, [fileDetailsTableData.length])

  const getMemberCodeByRFID = async () => {
    setIsScanLoading(true);
    try {
      const res = await axios.get(`http://localhost:8080/api/Aratek/MatchFingerprint`);
      if (!res.data.isSuccess) {
        toast.error(res.data.message || "Fingerprint match failed.");
        setIsScanLoading(false);
        return;
      }

      const resData = res.data.data.userCode;
      const rfiduser = res.data.data.rfid;

      const collectData = {
        mem_cd: resData,
        mem_ctgry: "",
        mem_inst: "",
        mem_dept: "",
        mem_degree: "",
        image: false
      };
      const memberResponse = await api.post(`Member/Getm_member`, collectData);

      if (!memberResponse.data.data || memberResponse.data.data.length === 0) {
        toast.error("Member details not found.");
        setIsScanLoading(false);
        return;
      }
      const member = memberResponse.data.data[0];
      let memberDetailarr = [{
        memberCode: member.mem_cd,
        rfid: rfiduser || member.rfid || "",
        firstName: member.mem_firstnm,
        middleName: member.mem_midnm,
        lastName: member.mem_lstnm,
        effectUpto: member.mem_effctupto,
        memCategory: member.mem_ctgry
      }];

      getMemberPhoto(resData || member.mem_cd);
      setASpplicableAcceOption([{ value: member.mem_cd, label: member.mem_firstnm }]);
      setmembCode(member.mem_cd);
      getBlockMember(member.mem_cd);
      setFileDetailsTableData(memberDetailarr);



      setShow(true); // Show details sections

      const systemIp = await getIP();
      if (!antina) {
        toast.error("Please Select Antenna.");
        setIsScanLoading(false);
        return;
      }

      const rfidScanData = {
        epc: "",
        mem_cd:resData,
        antnum: antina.toString(),
        type: "Issue",
        systemip: systemIp
      };
      const rfidResponse = await api.post('AssigningRfid/GetRfid', rfidScanData);

      if (!rfidResponse.data.isSuccess) {
        toast.info(rfidResponse.data.mesg || "No book data found from RFID scan.");
        // Continue even if no books are found, member is identified
      }

      let bookDetailsarr = [];
      if (rfidResponse.data.data) {
        for (const item of rfidResponse.data.data) {
          if (item.bookaccesioncls) {

            console.log('book item',item)
            for (const book of item.bookaccesioncls) {
              bookDetailsarr.push(book);
            }
          }
        }
        setBookTableData(bookDetailsarr);

        console.log('bookDetailsarr',bookDetailsarr)
        if (rfidResponse.data.mesg) toast.success(rfidResponse.data.mesg);
      }
      setAccordionExpanded(true);
      setIsScanLoading(false);

    } catch (error) {
      toast.error("Error during thumb issue process.");
      console.error("Thumb issue error:", error);
      setIsScanLoading(false);
    }
  };

  const accept1 = () => {
    api.get(`Member/DeleteMemberCardStatus?membercode=${membCode}`)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
      });
    SetStudentImage(profile1);
    setFileDetailsTableData([]);
    setBookTableData([]);
    setAccordionExpanded(false);
    setASpplicableAcceOption([]);
    setShow(false);
    setLoading(false);
    setmembCode("");
    setShow1(true);
    setShow2(false);
  };

  const reject1 = () => {
    toast.warn("Unblock Rejected", { autoClose: 3000 });
  };

  const handledeleteClick1 = () => {
    confirmDialog({
      message: "Do you want to Unblock this card?",
      header: "Unblock Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: accept1,
      reject: reject1,
    });
  };
  const handleSubmit = async () => {
    const selectedBooks = bookTableData.filter((row: any) => row.checkbox);
    if (selectedBooks.length === 0) {
      toast.error("No books selected for issue or return. Please check the boxes next to the books.");
      return;
    }

    const mem_cd = fileDetailsTableData[0]?.memberCode ?? "";
    const mem_ctgry = fileDetailsTableData[0]?.memCategory ?? "";

    const collectData = {
      mem_cd: mem_cd,
      mem_ctgry: mem_ctgry,
      slipNo: slipno,
      bookaccesioncls: selectedBooks.map((row: any) => ({
        recID: row.recID,
        p852: row.p852,
        status: row.status,
        tag245a: row.tag245a,
        tag245c: row.tag245c,
        lastOperatedDT: row.lastOperatedDT,
        mem_cd: row.mem_cd,
        issdmem_cd: row.issdmem_cd,
        iss_dt: row.iss_dt,
        due_dt: row.due_dt,
        checkbox: row.checkbox
      })),
      memberdetcls: fileDetailsTableData.map((row: any) => ({
        mem_cd: row.memberCode,
        rfid: row.rfid,
        mem_firstnm: row.firstName,
        mem_midnm: row.middleName,
        mem_lstnm: row.lastName,
        mem_effctupto: row.effectUpto,
        mem_ctgry: row.memCategory
      }))
    };

    try {
      const response = await api.post(`AssigningRfid/UpsertIssueReturn`, collectData);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        if (response.data.data && response.data.data.length > 0) {
          setPrintData(response.data.data);
          setTimeout(() => {
            handleDirectPrint();
          }, 500);
        }
        setFileDetailsTableData([]);
        setBookTableData([]);
        SetStudentImage(profile1);
        setmembCode("");
        setSelectedCheckbox(null);
      } else {
        toast.error(response.data.mesg);
      }
    } catch (error) {
      console.error("Error submitting data", error);
      toast.error("An error occurred while submitting the data.");
    }
  };
  const handleAccordionToggle = () => {
    setAccordionExpanded((prevExpanded) => !prevExpanded);
  };

  // const handleSelectAllCheckboxIS = (issuetype: string) => {
  //   setBookTableData((prevData: any) =>
  //     prevData.map((row: any) => {
  //       if (row.status === "AV") { // If trying to return, uncheck any "Issue" selections
  //         return { ...row, checkbox: false };
  //       }
  //       return row.status === issuetype ? { ...row, checkbox: !row.checkbox } : row;
  //     })
  //   );
  //   setSelectedCheckbox((prev) => (prev === issuetype ? null : issuetype));
  // };

  // const handleSelectAllCheckboxAV = (issuetype: string) => {
  //   const isReturning = bookTableData.some((row: any) => row.status === "IS" && row.checkbox);
  //   if (isReturning) {
  //     toast.error("Cannot select items for Issue while items are selected for Return. Please uncheck Return items first.");
  //     return;
  //   }
  //   setBookTableData((prevData: any) =>
  //     prevData.map((row: any) => {
  //       if (row.status === "IS") { // If trying to issue, uncheck any "Return" selections
  //         return { ...row, checkbox: false };
  //       }
  //       return row.status === issuetype ? { ...row, checkbox: !row.checkbox } : row;
  //     })
  //   );
  //   setSelectedCheckbox((prev) => (prev === issuetype ? null : issuetype));
  // };

const handleSelectAllCheckboxIS = (issuetype: string) => {
    setBookTableData((prevData: any) =>
      prevData.map((row: any) => {
        
        if (row.epc_match_status === 'Red') {
          return row; 
        }
        
        if (row.status === "AV") { // If trying to return, uncheck any "Issue" selections
          return { ...row, checkbox: false };
        }
        return row.status === issuetype ? { ...row, checkbox: !row.checkbox } : row;
      })
    );
    setSelectedCheckbox((prev) => (prev === issuetype ? null : issuetype));
  };

  const handleSelectAllCheckboxAV = (issuetype: string) => {
    const isReturning = bookTableData.some((row: any) => row.status === "IS" && row.checkbox);
    if (isReturning) {
      toast.error("Cannot select items for Issue while items are selected for Return. Please uncheck Return items first.");
      return;
    }
    setBookTableData((prevData: any) =>
      prevData.map((row: any) => {
        
        if (row.epc_match_status === 'Red') {
          return row;
        }
       
        if (row.status === "IS") { // If trying to issue, uncheck any "Return" selections
          return { ...row, checkbox: false };
        }
        return row.status === issuetype ? { ...row, checkbox: !row.checkbox } : row;
      })
    );
    setSelectedCheckbox((prev) => (prev === issuetype ? null : issuetype));
  };

  const handleCheckboxChange: any = (id: any) => {
    setBookTableData((prevData: any) =>
      prevData.map((row: any) => {
        if (row.p852 === id) {
          const newCheckedState = !row.checkbox;
          if (newCheckedState) { // If checking this box
            if (row.status === "IS" && selectedCheckbox === "AV") {
              toast.error("Clear 'Issue' selections before selecting 'Return'.");
              return row; // Don't change
            }
            if (row.status === "AV" && selectedCheckbox === "IS") {
              toast.error("Clear 'Return' selections before selecting 'Issue'.");
              return row; // Don't change
            }
            setSelectedCheckbox(row.status);
          }
          return { ...row, checkbox: newCheckedState };
        }
        return row;
      })
    );
    const anyCheckedInMode = bookTableData.some((r: any) => r.p852 !== id && r.checkbox && r.status === selectedCheckbox);
    const currentItem = bookTableData.find((r: any) => r.p852 === id);
    if (currentItem && !currentItem.checkbox && !anyCheckedInMode) {
      setSelectedCheckbox(null);
    }
  };

  const accept = async () => {
    setIsLoading(true);
    const collectData = {
      mem_code: membCode || "",
      cardStatus: "Blocked",
      blockedDateFrom: new Date().toISOString(),
      blockedDateupto: new Date().toISOString(),
    };
    try {
      const response = await api.post(`Member/AddUpdateMemberCardStatus`, collectData);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        setShow1(false);
        setShow2(true);
      } else {
        toast.error(response.data.mesg);
      }
    } catch (error) {
      toast.error("Failed to block card.");
      console.error("Block card error:", error);
    }
    setIsLoading(false);
  };



  const deleteAnteena = async () => {

    const collectData = {
      "epc": "",
      "antnum": antina,
      "type": "",
      "systemIp": ""
    };
    try {
      const response = await api.post(`AssigningRfid/DeleteRfidlog`, collectData);
      if (response.data.isSuccess) {
        console.log(response)
      }
    } catch (error) {
      toast.error("Failed to delete Anteena.");
      console.error("Delete error:", error);
    }

  };



  const reject = () => {
    toast.warn("Block operation cancelled.", { autoClose: 3000 });
  };

  const handledeleteClick = () => {
    if (!membCode) {
      toast.error("No member selected to block.");
      return;
    }
    confirmDialog({
      message: "Do you want to block this card?",
      header: "Block Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger", // PrimeReact class
      accept,
      reject,
    });
  };

  // FIX: Function to fetch member options for the dialog's autocomplete
  const getDialogMemb = async (nameData: string) => {
    if (!nameData || nameData.length < 2) {
      setDialogMemberOptions([]);
      return;
    }
    try {
      const res = await api.get(`AssigningRfid/GetMember?name=${nameData}`);
      const transformedData = res.data.map((item: any) => ({
        value: item.value,
        label: item.label,
      }));
      setDialogMemberOptions(transformedData);
    } catch (error) {
      console.error("Error fetching dialog members:", error);
      setDialogMemberOptions([]);
    }
  };


  const getList = (type: any) => {
    setIsLoading(true);
    // FIX: Use the dialog's member code state for filtering
    const collectData = {
      mem_cd: dialogMemberCode, type, user_cd: "", fromDate, toDate, useR_ID: Userid,
    };
    api.post(`Member/GetTotalIssueReturnData`, collectData)
      .then((res) => {
        const data = res.data.data || [];
        const arr = data.map((item: any, index: any) => ({ ...item, serialNo: index + 1, id: index + 1 }));
        setRows(arr);
        if (data.length > 0) {
          const cols: GridColDef[] = [
            { field: "serialNo", headerName: t("text.SrNo"), flex: 0.5, headerClassName: "MuiDataGrid-colCell" },
            { field: "mem_cd", headerName: "Member Code", flex: 1, headerClassName: "MuiDataGrid-colCell" },
            { field: "acc_no", headerName: "Accession No.", flex: 1, headerClassName: "MuiDataGrid-colCell" },
            { field: "iss_dt", headerName: "Issue Date", flex: 1, headerClassName: "MuiDataGrid-colCell", renderCell: (params) => new Date(params.value).toLocaleDateString("en-GB") },
            { field: "due_dt", headerName: "Due Date", flex: 1, headerClassName: "MuiDataGrid-colCell", renderCell: (params) => new Date(params.value).toLocaleDateString("en-GB") },
            { field: "user_cd", headerName: "User", flex: 1, headerClassName: "MuiDataGrid-colCell" },
          ];
          setColumns(cols as any);
        } else {
          setColumns([]);
        }
        setIsLoading(false);
      }).catch(err => {
        console.error("Error fetching list:", err);
        toast.error("Failed to fetch list data.");
        setIsLoading(false);
        setRows([]);
        setColumns([]);
      });
  };

  const getreturnList = (type: any) => {
    setIsLoading(true);
    // FIX: Use the dialog's member code state for filtering
    const collectData = {
      mem_cd: dialogMemberCode, type, user_cd: "", fromDate, toDate, useR_ID: Userid,
    };
    api.post(`Member/GetTotalIssueReturnData`, collectData)
      .then((res) => {
        const data = res.data.data || [];
        const arr = data.map((item: any, index: any) => ({ ...item, serialNo: index + 1, id: index + 1 }));
        setRows(arr);
        if (data.length > 0) {
          const cols: GridColDef[] = [
            { field: "serialNo", headerName: t("text.SrNo"), flex: 0.5, headerClassName: "MuiDataGrid-colCell" },
            { field: "mem_cd", headerName: "Member Code", flex: 1, headerClassName: "MuiDataGrid-colCell" },
            { field: "accn_no", headerName: "Accession No.", flex: 1, headerClassName: "MuiDataGrid-colCell" },
            { field: "iss_dt", headerName: "Issue Date", flex: 1, headerClassName: "MuiDataGrid-colCell", renderCell: (params) => new Date(params.value).toLocaleDateString("en-GB") },
            { field: "recv_dt", headerName: "Receive Date", flex: 1, headerClassName: "MuiDataGrid-colCell", renderCell: (params) => new Date(params.value).toLocaleDateString("en-GB") },
            { field: "recv_user_cd", headerName: "User", flex: 1, headerClassName: "MuiDataGrid-colCell" },
          ];
          setColumns(cols as any);
        } else {
          setColumns([]);
        }
        setIsLoading(false);
      }).catch(err => {
        console.error("Error fetching return list:", err);
        toast.error("Failed to fetch return list data.");
        setIsLoading(false);
        setRows([]);
        setColumns([]);
      });
  };

  // FIX: Added function to handle the search button click in the dialog
  const handleDialogSearch = () => {
    if (titlename === "Total Issued") {
      getList("all");
    } else if (titlename === "Today Issued") {
      getList("issue");
    } else if (titlename === "Today Return") {
      getreturnList("return");
    }
  };


  const AnimatedCount: React.FC<{ value: number }> = ({ value }) => {
    return <Typography variant="h4" component="span" fontWeight="bold">{value}</Typography>;
  };

  const summaryCardContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textAlign: 'center',
    p: 1,
  };

  const summaryCardIconStyle = {
    fontSize: '2rem',
    mb: 0.5,
  };

  const summaryCardValueStyle = {
    mt: 0.5,
    fontWeight: 'bold',
    fontSize: '1.5rem'
  };
  const summaryCardTitleStyle = {
    fontSize: '0.9rem',
    fontWeight: 500,
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <ConfirmDialog />
      <ToastContainer position="top-right" autoClose={3000} />

      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main', textAlign: 'center', mb: 3 }}>
        Issue Return
      </Typography>

   

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[
          {
            title: "Total Issue",
            value: totalIssue,
            icon: <LibraryBooksIcon fontSize="small" />,
            onClick: () => handleClickOpen("Total Issued"),
            color: "#4e79a7",
            gradient: "linear-gradient(135deg, #4e79a7 0%, #6b8cae 100%)"
          },
          {
            title: "Today Issue",
            value: todayIssue,
            icon: <EventAvailableIcon fontSize="small" />,
            onClick: () => handleClickOpen("Today Issued"),
            color: "#59a14f",
            gradient: "linear-gradient(135deg, #59a14f 0%, #8ab97c 100%)"
          },
          {
            title: "Today Return",
            value: todayReturn,
            icon: <AssignmentReturnIcon fontSize="small" />,
            onClick: () => handleClickOpen("Today Return"),
            color: "#f28e2b",
            gradient: "linear-gradient(135deg, #f28e2b 0%, #f5b976 100%)"
          },
          {
            title: "Today Still Inside",
            value: loadingCounts.stillInside ? null : todayStillInsideCount,
            icon: <PeopleIcon fontSize="small" />,
            onClick: async () => {
              setVisitorDialogOpen(true);
              await fetchVisitorInfoStillInside();
            },
            color: "#b07aa1",
            gradient: "linear-gradient(135deg, #b07aa1 0%, #d4a5c9 100%)",
            loading: loadingCounts.stillInside
          },
          {
            title: "Today Visitor",
            value: loadingCounts.visitor ? null : todayVisitorCount,
            icon: <PersonIcon fontSize="small" />,
            onClick: async () => {
              setVisitorInfoDialogOpen(true);
              await fetchVisitorInfo();
            },
            color: "#76b7b2",
            gradient: "linear-gradient(135deg, #76b7b2 0%, #a3d8d4 100%)",
            loading: loadingCounts.visitor
          },
        ].map((card) => (
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4} key={card.title}>
            <Paper
              elevation={0}
              sx={{
                p: 1.5,
                borderRadius: '12px',
                height: '100px',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                background: card.gradient,
                color: 'white',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 6px 20px rgba(0,0,0,0.1)'
                },
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: '-50%',
                  right: '-50%',
                  width: '100%',
                  height: '100%',
                  background: 'rgba(255,255,255,0.1)',
                  transform: 'rotate(30deg)',
                  transition: 'all 0.3s ease'
                },
                '&:hover::before': {
                  transform: 'rotate(30deg) translateX(50px)'
                }
              }}
              onClick={card.onClick}
            >
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                zIndex: 1
              }}>
                <Typography variant="subtitle2" sx={{
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  opacity: 0.9
                }}>
                  {card.title}
                </Typography>
                <Box sx={{
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  width: 32,
                  height: 32,
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  ml: 1,
                  backdropFilter: 'blur(2px)'
                }}>
                  {React.cloneElement(card.icon, { sx: { color: 'white' } })}
                </Box>
              </Box>

              {card.loading ? (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '32px',
                  alignItems: 'center',
                  zIndex: 1
                }}>
                  <CircularProgress size={20} color="inherit" sx={{ color: 'rgba(255,255,255,0.8)' }} />
                </Box>
              ) : card.value !== null ? (
                <Box sx={{ zIndex: 1 }}>
                  <Typography variant="h4" sx={{
                    fontWeight: 'bold',
                    lineHeight: 1,
                    mt: 0.5,
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}>
                    {card.value}
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ height: '32px', zIndex: 1 }} />
              )}

              {/* Decorative elements */}
              <Box sx={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                zIndex: 0
              }} />
              <Box sx={{
                position: 'absolute',
                bottom: '-10px',
                right: '-10px',
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.05)',
                zIndex: 0
              }} />
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper elevation={3} sx={{ p: 2, mb: 3, borderRadius: '12px' }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={7}>
            <Stack spacing={2}>
              <TextField
                label="Slip No"
                placeholder="Enter Slip No"
                size="small"
                fullWidth
                value={slipno}
                onChange={(e: any) => { setSlipNo(e.target.value) }}
                InputLabelProps={{ shrink: true }}
              />
              <Autocomplete
                disablePortal
                options={selectOption}
                fullWidth
                size="small"
                value={antinaselect}
                onChange={(event: any, newValue: any) => {
                  setAntinaselect(newValue);
                  setAntina(newValue?.value);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Antenna" InputLabelProps={{ shrink: true }} />
                )}
              />
              <Button
                variant="contained"
                fullWidth
                startIcon={<ScanIcon />}
                onClick={getAntennaScan}
                disabled={loading || isScanloading}
                sx={{ py: 1.5 }}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'SCAN FOR BOOKS/MEMBER CARD'}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                startIcon={<FingerprintIcon />}
                onClick={getMemberCodeByRFID}
                disabled={loading || isScanloading}
                sx={{ py: 1.5 }}
              >
                {isScanloading ? <CircularProgress size={24} color="inherit" /> : 'SCAN MEMBER THUMB & BOOKS'}
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box
              component="img"
              src={studentimage || profile1}
              alt="Member"
              sx={{
                width: '100%',
                maxWidth: '150px',
                height: '200px',
                objectFit: 'cover',
                border: '2px solid',
                borderColor: 'divider',
                borderRadius: '8px',
                backgroundColor: 'grey.200'
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {show && (
        <>
          <Accordion expanded={accordionExpanded} onChange={handleAccordionToggle} sx={{ mb: 2, '&.Mui-expanded': { marginBlock: '16px' } }}>
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              sx={{ backgroundColor: 'primary.light', color: 'primary.contrastText', borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }}
            >
              <Typography sx={{ fontWeight: 'medium' }}>Member Details</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <TableContainer component={Paper} sx={{ borderRadius: 0, boxShadow: 'none' }}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: 'grey.200' }}>
                    <TableRow>
                      {["Sr.No.", "Member Code", "RFID No", "First Name", "Middle Name", "Last Name", "Effective Date", "Category"].map(header => (
                        <TableCell key={header} sx={{ fontWeight: 'bold' }}>{header}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fileDetailsTableData.map((row: any, index: any) => (
                      <TableRow key={index} hover>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.memberCode || '--'}</TableCell>
                        <TableCell>{row.rfid || '--'}</TableCell>
                        <TableCell>{row.firstName || '--'}</TableCell>
                        <TableCell>{row.middleName || '--'}</TableCell>
                        <TableCell>{row.lastName || '--'}</TableCell>
                        <TableCell>
                          {row.effectUpto ? <Moment format="DD-MM-YYYY">{row.effectUpto}</Moment> : '--'}
                        </TableCell>
                        <TableCell>{row.memCategory || '--'}</TableCell>
                      </TableRow>
                    ))}
                    {fileDetailsTableData.length === 0 && (

                      <TableRow>
                        <TableCell colSpan={8} align="center">No member details to display.</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={accordionExpanded} onChange={handleAccordionToggle} sx={{ mb: 3, '&.Mui-expanded': { marginBlock: '16px' } }}>
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              sx={{ backgroundColor: 'primary.light', color: 'primary.contrastText', borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }}
            >
              <Typography sx={{ fontWeight: 'medium' }}>Book Details</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
                <Checkbox
                  checked={selectedCheckbox === "IS"}
                  onChange={() => handleSelectAllCheckboxIS("IS")}
                  size="small"
                />
                <Typography component="span" variant="body2" onClick={() => handleSelectAllCheckboxIS("IS")} sx={{ cursor: 'pointer', mr: 2 }}>
                  Select All for Return
                </Typography>

                <Checkbox
                  checked={selectedCheckbox === "AV"}
                  onChange={() => handleSelectAllCheckboxAV("AV")}
                  size="small"
                />
                <Typography component="span" variant="body2" onClick={() => handleSelectAllCheckboxAV("AV")} sx={{ cursor: 'pointer', mr: 2 }}>
                  Select All for Issue
                </Typography>
              </Box>
              <TableContainer component={Paper} sx={{ borderRadius: 0, boxShadow: 'none' }}>
                <Table size="small">
                  <TableHead sx={{ backgroundColor: 'grey.200' }}>
                    <TableRow>
                      {["Sr.No.", "Accession No", "Title", "Status", "Author", "Issued To", "Issue Date", "Due Date"].map(header => (
                        <TableCell key={header} sx={{ fontWeight: 'bold' }}>{header}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {bookTableData.map((row: any, index: any) => (
                      <TableRow
                        key={index}
                        hover
                        selected={row.checkbox}
                        sx={{
                          backgroundColor:
                            row.epc_match_status === 'Red'
                              ? 'rgba(255, 0, 0, 0.15)'
                              : row.epc_match_status === 'Green'
                              ? 'rgba(0, 255, 0, 0.15)'
                              : 'inherit',
                          ...(row.epc_match_status === 'Red' && {
                            opacity: 0.65,
                            cursor: 'not-allowed',
                          }),
                        }}
                      >
                        <TableCell>{index + 1}</TableCell>
                        <TableCell style={{ width: "15%" }}>
                          <Checkbox
                            size="small"
                            checked={row.epc_match_status === 'Red' ? false : row.checkbox || false}
                            onChange={() => handleCheckboxChange(row.p852)}
                            disabled={row.epc_match_status === 'Red' || !!(selectedCheckbox && selectedCheckbox !== row.status)}
                          />
                          {row.p852 || '--'}
                        </TableCell>
                        <TableCell>{row.tag245a || '--'}</TableCell>
                        <TableCell>{row.status || '--'}</TableCell>
                        <TableCell>{row.tag245c || '--'}</TableCell>
                        <TableCell>{row.issdmem_cd || '--'}</TableCell>
                        <TableCell>
                          {row.iss_dt ? <Moment format="DD-MM-YYYY">{row.iss_dt}</Moment> : '--'}
                        </TableCell>
                        <TableCell>
                          {row.due_dt ? <Moment format="DD-MM-YYYY">{row.due_dt}</Moment> : '--'}
                        </TableCell>
                      </TableRow>
                    ))}
                    {bookTableData.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={8} align="center">No book details to display.</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </>
      )}


      <Grid container spacing={2} justifyContent="center">
        {show1 && (
          <Grid item xs={12} md={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSubmit}
              disabled={!fileDetailsTableData.length && !bookTableData.length}
              sx={{ py: 1.5, fontSize: '1rem' }}
            >
              Issue / Return
            </Button>
          </Grid>
        )}
        {show1 && show && (
          <Grid item xs={12} md={4}>
            <Button
              fullWidth
              variant="contained"
              size="small"
              startIcon={<BlockIcon />}
              onClick={handledeleteClick}
              disabled={!membCode}
              sx={{ py: 1.5, fontSize: '1rem', backgroundColor: 'error.main', '&:hover': { backgroundColor: 'error.dark' } }}
            >
              Block Card
            </Button>
          </Grid>
        )}
        {show2 && (
          <Grid item xs={12} md={4}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              size="small"
              startIcon={<LockOpenIcon />}
              onClick={handledeleteClick1}
              disabled={!membCode}
              sx={{ py: 1.5, fontSize: '1rem' }}
            >
              Unblock Card
            </Button>
          </Grid>
        )}


        <Grid item xs={12} md={4}>
          <Button
            fullWidth
            variant="contained"
            style={{ backgroundColor: "#5a6070" }}
            size="small"
            onClick={() => { // --- CAMBIO 3: Usar la nueva función de reseteo ---
              resetUI();
              deleteAnteena();
            }}
            sx={{ py: 1.5, fontSize: '1rem' }}
          >
            Reset
          </Button>
        </Grid>
      </Grid>

      <div id="receipt-content" ref={contentRef} className="pos-receipt" style={{ display: "none" }}>
        <div className="">  <img src={loged} width={50} height={50} alt="Logo" /></div>
        <div className="pos-title">{printData[0]?.header}</div>
        <div className="pos-title">{printData[0]?.title}</div>
        <hr />
        <table>
          {printData.length > 0 && (<tbody>
            <tr><td>Member Code</td><td>{printData[0]["memberId"]}</td></tr>
            <tr><td>Current Date</td><td>{moment(new Date()).format("DD-MM-YYYY")}</td></tr>
            <tr><td>Due Date</td><td>{printData[0]["dueDate"]}</td></tr>
            <tr><td>Acc. No</td><td>{printData[0]["accNo"]}</td></tr>
            {printData[0]["fine"] && printData[0]["fine"].length > 0 && (<tr><td>Fine</td><td>{printData[0]["fine"]}</td></tr>)}
            <tr><td colSpan={2}>{printData[0]["message"]}</td></tr>
          </tbody>)}
        </table>
        <hr />
      </div>

      <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: 'primary.main', color: 'white' }}>{titlename}</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ pt: 2 }}>
            {isLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
                  <Grid item xs={12} sm={titlename !== "Total Issued" ? 5 : 3} >
                    {/* FIX: Connected Autocomplete to dialog state and functions */}
                    <Autocomplete
                      options={dialogMemberOptions}
                      getOptionLabel={(option: any) => option.label || ""}
                      fullWidth
                      size="small"
                      onInputChange={(event, newInputValue) => {
                        getDialogMemb(newInputValue);
                      }}
                      onChange={(event, newValue) => {
                        setDialogMemberCode(newValue ? newValue.value : null);
                      }}
                      renderInput={(params) => <TextField {...params} label="Select Member Code" />}
                    />
                  </Grid>
                  {titlename === "Total Issued" && (
                    <>
                      <Grid item xs={12} sm={3}>
                        <TextField type="Date" InputLabelProps={{ shrink: true }} label="From Date" size="small" fullWidth onChange={(e: any) => setfromDate(e.target.value)} />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField type="Date" InputLabelProps={{ shrink: true }} label="To Date" size="small" fullWidth onChange={(e: any) => settoDate(e.target.value)} />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={titlename !== "Total Issued" ? 5 : 3}>
                    {/* FIX: Connected Search button to the handler function */}
                    <Button variant="contained" onClick={handleDialogSearch}>Search</Button>
                  </Grid>
                </Grid>
                <Box sx={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{ toolbar: { showQuickFilter: true } }}
                    sx={{ border: 0, '& .MuiDataGrid-columnHeaders': { backgroundColor: 'primary.light', color: 'primary.contrastText' } }}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 5 } },
                    }}
                    pageSizeOptions={[5, 10, 25, 50, 100]}
                  />
                </Box>
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose} variant="outlined">Close</Button>
        </DialogActions>
      </Dialog>





      {/* Still Inside Visitors Dialog */}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={visitorDialogOpen}
        onClose={() => {
          // Reset all filters when dialog closes
          setTimePeriod('Today');
          const today = new Date().toISOString().split('T')[0];
          setfromDate(today);
          settoDate(today);
          setDialogMemberCode(null);
          setProgram(null);
          setDepartment1(null);
          setCategory(null);
          setShowMoreFilters(false);
          setVisitorDialogOpen(false);
        }}
      >
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>Visitors Still Inside</span>
          <Box>
            <Button
              variant="contained"
              size="small"
              startIcon={<PrintIcon />}
              onClick={() => handleDialogPrint(visitorData, "Visitors Still Inside Report")}
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                marginRight: '8px',
                '&:hover': { backgroundColor: 'grey.100' }
              }}
            >
              Print
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                // Reset all filters when close button is clicked
                setTimePeriod('Today');
                const today = new Date().toISOString().split('T')[0];
                setfromDate(today);
                settoDate(today);
                setDialogMemberCode(null);
                setProgram(null);
                setDepartment1(null);
                setCategory(null);
                setShowMoreFilters(false);
                setVisitorDialogOpen(false);
              }}
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                '&:hover': { backgroundColor: 'grey.100' }
              }}
            >
              Close
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <form onSubmit={(e) => {
            e.preventDefault();
            fetchVisitorInfoStillInside();
          }}>
            <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
              {/* First Row - Main Filters */}
              
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={dialogMemberOptions}
                  getOptionLabel={(option: any) => option.label || ""}
                  fullWidth
                  size="small"
                  onInputChange={(event, newInputValue) => {
                    getDialogMemb(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    setDialogMemberCode(newValue ? newValue.value : null);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Member Code" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Time Period"
                  value={timePeriod}
                  onChange={(e) => handleTimePeriodChange(e.target.value)}
                  fullWidth
                  size="small"
                >
                  {['Today', 'Weekly', 'Monthly', 'Yearly', 'Custom'].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="From"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={fromDate || ''}
                  onChange={(e) => setfromDate(e.target.value)}
                  disabled={timePeriod !== 'Custom'}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="To"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={toDate || ''}
                  onChange={(e) => settoDate(e.target.value)}
                  disabled={timePeriod !== 'Custom'}
                />
              </Grid>

              {/* Second Row - Action Buttons */}
              <Grid item xs={12} sm={3}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<FilterListIcon />}
                  endIcon={showMoreFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  onClick={() => setShowMoreFilters(!showMoreFilters)}
                  size="small"
                  sx={{ height: '40px' }}
                  type="button"
                >
                  More Filters
                </Button>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={fetchVisitorInfoStillInside}
                  startIcon={<SearchIcon />}
                  size="small"
                  sx={{ height: '40px' }}
                  type="submit"
                  disabled={visitorLoading}
                >
                  {visitorLoading ? <CircularProgress size={20} /> : 'Search'}
                </Button>
              </Grid>

              {/* Additional Filters Section */}
              <Grid item xs={12}>
                <Collapse in={showMoreFilters}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        options={categoryOptions}
                        getOptionLabel={(option) => option.label}
                        value={categoryOptions.find(opt => opt.value === category) || null}
                        onChange={(event, newValue) => {
                          setCategory(newValue ? newValue.value : null);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Category" />
                        )}
                        fullWidth
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        options={programOptions}
                        getOptionLabel={(option) => option.label}
                        value={programOptions.find(opt => opt.value === program) || null}
                        onChange={(event, newValue) => {
                          setProgram(newValue ? newValue.value : null);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Program" />
                        )}
                        fullWidth
                        size="small"
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        options={departmentOptions}
                        getOptionLabel={(option) => option.label}
                        value={departmentOptions.find(opt => opt.value === department1) || null}
                        onChange={(event, newValue) => {
                          setDepartment1(newValue ? newValue.value : null);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Department" />
                        )}
                        fullWidth
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </Collapse>
              </Grid>
            </Grid>
          </form>

          {visitorData.length > 0 ? (
            <Box sx={{
              height: 500,
              width: '100%',
              overflowX: 'auto'
            }}>
              <Box sx={{
                minWidth: '1200px',
                width: '100%'
              }}>
                <DataGrid
                  rows={visitorData.map((item, index) => ({
                    ...item,
                    id: index,
                    srNo: index + 1,
                    mobileNo: item.mobileNo ? item.mobileNo.split(',')[0] : ''
                  }))}
                  columns={[
                    { field: 'srNo', headerName: 'Sr. No.', width: 80 },
                    { field: 'm_memcd', headerName: 'Member Code', width: 150 },
                    { field: 'mname', headerName: 'Name', width: 180 },
                    { field: 'mobileNo', headerName: 'Mobile', width: 120 },
                    { field: 'mem_ctgry', headerName: 'Category', width: 120 },
                    { field: 'mem_degree', headerName: 'Program', width: 120 },
                    { field: 'mem_dept', headerName: 'Department', width: 150 },
                    { field: 'mem_type', headerName: 'Type', width: 100 },
                    {
                      field: 'inTime',
                      headerName: 'Entry Time',
                      width: 150,
                      renderCell: (params) => (
                        <Moment format="DD-MM-YYYY HH:mm:ss">{params.value}</Moment>
                      )
                    },
                    {
                      field: 'vdate',
                      headerName: 'Visit Date',
                      width: 120,
                      renderCell: (params) => (
                        <Moment format="DD-MM-YYYY">{params.value}</Moment>
                      )
                    },
                    {
                      field: 'spendtime',
                      headerName: 'Duration',
                      width: 120,
                      renderCell: (params) => (
                        <Typography color="error.main" fontWeight="bold">
                          {params.value}
                        </Typography>
                      )
                    }
                  ]}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 10, page: 0 },
                    },
                  }}
                  pageSizeOptions={[10, 25, 50]}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                  sx={{
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: 'primary.light',
                      color: 'white'
                    },
                    '& .MuiDataGrid-virtualScroller': {
                      overflowX: 'auto'
                    }
                  }}
                />
              </Box>
            </Box>
          ) : (
            <Box sx={{
              p: 4,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              height: 300
            }}>
              <LockOpenIcon color="success" sx={{ fontSize: 48 }} />
              <Typography variant="h6">No visitors currently inside</Typography>
              <Typography variant="body2" color="text.secondary">
                All visitors have checked out
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Today Visitor Dialog */}


      <Dialog
        fullWidth
        maxWidth="lg"
        open={visitorInfoDialogOpen}
        onClose={() => {
          // Reset all filters when dialog closes
          setTimePeriod('Today');
          const today = new Date().toISOString().split('T')[0];
          setfromDate(today);
          settoDate(today);
          setDialogMemberCode(null);
          setProgram(null);
          setDepartment1(null);
          setCategory(null);
          setShowMoreFilters(false);
          setVisitorInfoDialogOpen(false);
        }}
      >
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>Today's Visitors</span>
          <Box>
            <Button
              variant="contained"
              size="small"
              startIcon={<PrintIcon />}
              onClick={() => handleDialogPrint(
                visitorInfoData.filter(visitor => visitor.outTime !== null),
                "Today's Visitors Report"
              )}
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                marginRight: '8px',
                '&:hover': { backgroundColor: 'grey.100' }
              }}
            >
              Print
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                // Reset all filters when close button is clicked
                setTimePeriod('Today');
                const today = new Date().toISOString().split('T')[0];
                setfromDate(today);
                settoDate(today);
                setDialogMemberCode(null);
                setProgram(null);
                setDepartment1(null);
                setCategory(null);
                setShowMoreFilters(false);
                setVisitorInfoDialogOpen(false);
              }}
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                '&:hover': { backgroundColor: 'grey.100' }
              }}
            >
              Close
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <form onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}>
            <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
              {/* First Row - Main Filters */}
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={dialogMemberOptions}
                  getOptionLabel={(option: any) => option.label || ""}
                  fullWidth
                  size="small"
                  onInputChange={(event, newInputValue) => {
                    getDialogMemb(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    setDialogMemberCode(newValue ? newValue.value : null);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Member Code" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Time Period"
                  value={timePeriod}
                  onChange={(e) => handleTimePeriodChange(e.target.value)}
                  fullWidth
                  size="small"
                >
                  {['Today', 'Weekly', 'Monthly', 'Yearly', 'Custom'].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="From"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={fromDate || ''}
                  onChange={(e) => setfromDate(e.target.value)}
                  disabled={timePeriod !== 'Custom'}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="To"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={toDate || ''}
                  onChange={(e) => settoDate(e.target.value)}
                  disabled={timePeriod !== 'Custom'}
                />
              </Grid>

              {/* Second Row - Action Buttons */}
              <Grid item xs={12} sm={3}>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<FilterListIcon />}
                  endIcon={showMoreFilters ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  onClick={() => setShowMoreFilters(!showMoreFilters)}
                  size="small"
                  sx={{ height: '40px' }}
                  type="button"
                >
                  More Filters
                </Button>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  size="small"
                  sx={{ height: '40px' }}
                  type="submit"
                  disabled={visitorInfoLoading}
                >
                  {visitorInfoLoading ? <CircularProgress size={20} /> : 'Search'}
                </Button>
              </Grid>

              {/* Additional Filters Section */}
              <Grid item xs={12}>
                <Collapse in={showMoreFilters}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        options={categoryOptions}
                        getOptionLabel={(option) => option.label}
                        value={categoryOptions.find(opt => opt.value === category) || null}
                        onChange={(event, newValue) => {
                          setCategory(newValue ? newValue.value : null);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Category" />
                        )}
                        fullWidth
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        options={programOptions}
                        getOptionLabel={(option) => option.label}
                        value={programOptions.find(opt => opt.value === program) || null}
                        onChange={(event, newValue) => {
                          setProgram(newValue ? newValue.value : null);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Program" />
                        )}
                        fullWidth
                        size="small"
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                        options={departmentOptions}
                        getOptionLabel={(option) => option.label}
                        value={departmentOptions.find(opt => opt.value === department1) || null}
                        onChange={(event, newValue) => {
                          setDepartment1(newValue ? newValue.value : null);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Department" />
                        )}
                        fullWidth
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </Collapse>
              </Grid>
            </Grid>
          </form>

          {visitorInfoData.length > 0 ? (
            <Box sx={{
              height: 500,
              width: '100%',
              overflowX: 'auto'
            }}>
              <Box sx={{
                minWidth: '1200px',
                width: '100%'
              }}>
                <DataGrid
                  rows={visitorInfoData
                    //  .filter(visitor => visitor.outTime !== null)
                    .map((item, index) => ({
                      ...item,
                      id: index,
                      srNo: index + 1,
                      mobileNo: item.mobileNo ? item.mobileNo.split(',')[0] : ''
                    }))}
                  columns={[
                    { field: 'srNo', headerName: 'Sr. No.', width: 80 },
                    { field: 'm_memcd', headerName: 'Member Code', width: 150 },
                    { field: 'mname', headerName: 'Name', width: 180 },
                    { field: 'mobileNo', headerName: 'Mobile', width: 120 },
                    { field: 'mem_ctgry', headerName: 'Category', width: 120 },
                    { field: 'mem_degree', headerName: 'Program', width: 120 },
                    { field: 'mem_dept', headerName: 'Department', width: 150 },
                    { field: 'mem_type', headerName: 'Type', width: 100 },
                    {
                      field: 'inTime',
                      headerName: 'Entry Time',
                      width: 150,
                      renderCell: (params) => (
                        <Moment format="DD-MM-YYYY HH:mm:ss">{params.value}</Moment>
                      )
                    },
                    {
                      field: 'outTime',
                      headerName: 'Exit Time',
                      width: 150,
                      renderCell: (params) =>
                        params.value ? (
                          <Moment format="DD-MM-YYYY HH:mm:ss">{params.value}</Moment>
                        ) : (
                          <Typography color="warning.main" fontWeight="bold">
                            Still Inside
                          </Typography>
                        )
                    },

              {
                      field: 'vdate',
                      headerName: 'Visit Date',
                      width: 120,
                      renderCell: (params) => (
                        <Moment format="DD-MM-YYYY">{params.value}</Moment>
                      )
                    },
                    {
                      field: 'spendtime',
                      headerName: 'Duration',
                      width: 120,
                      renderCell: (params) => (
                        <Typography color="error.main" fontWeight="bold">
                          {params.value}
                        </Typography>
                      )
                    }
                  ]}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 10, page: 0 },
                    },
                  }}
                  pageSizeOptions={[10, 25, 50]}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                  sx={{
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: 'primary.light',
                      color: 'white'
                    },
                    '& .MuiDataGrid-virtualScroller': {
                      overflowX: 'auto'
                    }
                  }}
                />
              </Box>
            </Box>
          ) : (
            <Box sx={{
              p: 4,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              height: 300
            }}>
              <PeopleIcon color="action" sx={{ fontSize: 48 }} />
              <Typography variant="h6">No visitor data found</Typography>
              <Typography variant="body2" color="text.secondary">
                Try adjusting your search filters
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      {/* <OverdueListDialog open={openDialog} handleClose={() => setOpenDialog(false)} /> */}

    </Box>
  );
};

export default IssueReturn;